import NoData from '@/assets/images/noData.png';
import { Empty, InfiniteScroll } from 'antd-mobile';
import styles from './index.module.scss';
import outStyles from '../../index.module.scss';
import { AdminPageResponse, DayDataVO } from '@/api/energy';
import dayjs from 'dayjs';
import { formatTimeRange } from '@/pages/EnergyUsePlan/util';
import { useSyncHorizontalScroll } from './hook';
import { PlanType } from '../../util';
import { isEmpty } from 'lodash-es';

function groupByOwnerOrg(data: AdminPageResponse[]) {
  const map = new Map();
  data.forEach(item => {
    if (!map.has(item.ownerOrgId)) {
      map.set(item.ownerOrgId, {
        ownerOrgId: item.ownerOrgId,
        ownerOrgName: item.ownerOrgName,
        areas: [],
      });
    }
    map.get(item.ownerOrgId).areas.push({
      areaId: item.areaId,
      areaName: item.areaName,
      day1Data: item.day1Data,
      day2Data: item.day2Data,
      day3Data: item.day3Data,
      day4Data: item.day4Data,
      day5Data: item.day5Data,
      day6Data: item.day6Data,
      day7Data: item.day7Data,
    });
  });
  return Array.from(map.values());
}

interface ListProp {
  hasMore?: boolean;
  loadMore: () => Promise<void>;
  activeTab?: string;
  data?: AdminPageResponse[];
  dateRange?: [dayjs.Dayjs, dayjs.Dayjs | null];
  onClickDetail: (data: any) => void;
}
const List = ({ dateRange, onClickDetail, hasMore, loadMore, activeTab, data = [] }: ListProp) => {
  const scrollRefs = useSyncHorizontalScroll(data, activeTab);

  const groupedData = groupByOwnerOrg(data);
  return data.length > 0 ? (
    <div className={styles.container}>
      {groupedData.map((org, index) => (
        <div key={org.ownerOrgId} className={styles.list}>
          <div className={styles.title}>{org.ownerOrgName}</div>
          {org.areas.map((area: any, index: number) => (
            <div key={area.areaId} className={styles.card}>
              <div className={styles.subTitle}>{area.areaName}</div>
              <div className={styles.cardContent} ref={el => (scrollRefs.current[`${area.areaId}${index}`] = el)}>
                {[1, 2, 3, 4, 5, 6, 7].map(dayNum => {
                  const dayData = area[`day${dayNum}Data`] || [];
                  const day = dateRange![0].add(dayNum - 1, 'day');
                  const dateStr = day.format('YYYY-MM-DD');
                  return (
                    <div
                      key={dayNum}
                      className={styles.cartItem}
                      onClick={() => {
                        const ownerOrgId = org.ownerOrgId;
                        const areaId = area.areaId;
                        onClickDetail({
                          ownerOrgId,
                          areaId,
                          day: dayjs(dateStr).valueOf(),
                        });
                      }}
                    >
                      <div className={styles.dayTitle}>{dateStr}</div>
                      <div className={styles.areaDay}>
                        {dayData.length > 0 ? (
                          dayData.map((item: DayDataVO, idx: number) => (
                            <div
                              key={idx}
                              className={`${
                                item.type === PlanType.DELAY_ENERGY ? outStyles.delayEnergyItem : outStyles.energyItem
                              }`}
                            >
                              {formatTimeRange(item.day!, item.startDateTime, item.endDateTime)}
                            </div>
                          ))
                        ) : (
                          <div style={{ fontSize: 11, color: '#ccc' }}>暂无计划</div>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      ))}
      {!isEmpty(data) && hasMore && <InfiniteScroll loadMore={loadMore} hasMore={hasMore} />}
    </div>
  ) : (
    <div className={outStyles.emptyState}>
      <Empty image={NoData} description="暂无数据" />
    </div>
  );
};

export default List;
